module.exports = __webpack_public_path__ + "img/capa-padrao.ba05e577.png";